function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 122.88 111.54"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.35 84.42 45.28 10.2l.17-.27a23 23 0 0 1 7.05-7.24A17 17 0 0 1 61.57 0a16.7 16.7 0 0 1 9.11 2.69 22.8 22.8 0 0 1 7 7.26q.19.32.36.63l42.23 73.34.24.44a22.5 22.5 0 0 1 2.37 10.19 17.6 17.6 0 0 1-2.17 8.35 15.94 15.94 0 0 1-6.93 6.6c-.19.1-.39.18-.58.26a21.2 21.2 0 0 1-9.11 1.75H16.96a18.1 18.1 0 0 1-6.2-1.15A16.4 16.4 0 0 1 3 104.24a17.53 17.53 0 0 1-3-9.57 23 23 0 0 1 1.57-8.74 7.7 7.7 0 0 1 .77-1.51Z",
  style: {
    fill: "#cf1f25"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m9 88.75 43.12-74.59c5.24-8.25 13.54-8.46 18.87 0l42.43 73.69c3.39 6.81 1.71 16-9.33 15.77H17.61c-7.26.18-11.94-6.19-8.61-14.87",
  style: {
    fill: "#fec901",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.57 83.78A5.53 5.53 0 0 1 61 82.2a5.6 5.6 0 0 1 2.4.36 5.7 5.7 0 0 1 2 1.3 5.56 5.56 0 0 1 1.54 5 6.2 6.2 0 0 1-.42 1.35 5.57 5.57 0 0 1-5.22 3.26 5.7 5.7 0 0 1-2.27-.53A5.5 5.5 0 0 1 56.28 90a5.2 5.2 0 0 1-.36-1.27 5.8 5.8 0 0 1-.06-1.31 6.5 6.5 0 0 1 .57-2 4.7 4.7 0 0 1 1.14-1.56Zm8.15-10.24c-.19 4.79-8.31 4.8-8.49 0-.82-8.21-2.92-29.34-2.86-37.05.07-2.38 2-3.79 4.56-4.33a12.8 12.8 0 0 1 5 0c2.61.56 4.65 2 4.65 4.44v.24z",
  style: {
    fill: "#010101"
  }
}));
export default SvgIconAlert;